/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createStatusGetResponseFromDiscriminatorValue, type StatusGetResponse } from '../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /status
 */
export interface StatusRequestBuilder extends BaseRequestBuilder<StatusRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<StatusGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<StatusGetResponse[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const StatusRequestBuilderUriTemplate = "{+baseurl}/status";
/**
 * Metadata for all the requests in the request builder.
 */
export const StatusRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StatusRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createStatusGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
